<template>
  <div class="multi-npc-container">
    <b-tabs content-class="mt-0" fill>
      <b-tab
        v-for="(ch, index) in multiCh"
        :key="ch"
        :title="ch"
      >
        <iframe
          :src="iframeSrc(ch, index)"
          class="npc-iframe"
          allowfullscreen
        ></iframe>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { seedFrameSession } from "../authStorage";

export default {
  name: "MultiNPC",
  props: {
    multiCh: {
      type: Array,
      required: true,
    },
  },
  methods: {
    iframeSrc(ch, index) {
      // 保留原本的一次登入流程，將授權提供給各子 iframe 的獨立儲存位置。
      seedFrameSession(ch, index);
      const base = window.location.pathname;
      return `${base}#/chat?ch=${encodeURIComponent(ch)}&demoMode=true`;
    },
  },
};
</script>

<style scoped>
.multi-npc-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.multi-npc-container > .tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.npc-iframe {
  width: 100%;
  height: calc(100vh - 50px);
  border: none;
  display: block;
}
</style>
